import { cn, Text, type TextVariant } from '@mntn/ui-components'

type TitleType = 'header' | 'subheader'
type TitleStyle = {
  variant: TextVariant
  className: string
}

const TITLE_STYLE: Record<TitleType, TitleStyle> = {
  header: {
    variant: 'base',
    className: 'text-primary-inverse base-sm',
  },
  subheader: {
    variant: 'base-sm',
    className: 'uppercase text-secondary base-xs',
  },
}

export interface ProgressSummaryProps {
  title: string
  titleType: TitleType
  value?: number
  total?: number
  unit?: string
  formatValue?: (val: number) => string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const ProgressSummary: React.FC<ProgressSummaryProps> = ({
  title,
  titleType,
  value,
  total,
  formatValue = val => val.toLocaleString(),
}) => {
  const isEmpty = value == null
  return (
    <div className="flex flex-col min-w-0 py-4 px-6">
      <Text
        variant={TITLE_STYLE[titleType].variant}
        className={cn('truncate uppercase', TITLE_STYLE[titleType].className)}
      >
        {title}
      </Text>
      {!isEmpty &&
        (typeof total === 'number' && total >= 0 ? (
          <span className="flex items-baseline whitespace-nowrap">
            <Text inline className="text-header-inverse mr-1" variant="number-lg">
              {formatValue(value ?? 0)}
            </Text>
            <Text inline className="text-secondary-inverse" variant="base-sm">
              of {formatValue(total ?? 0)}
            </Text>
          </span>
        ) : (
          <Text inline variant="number-lg" className="text-secondary-accent-inverse">
            {formatValue(value ?? 0)}
          </Text>
        ))}
      {isEmpty && <div className="h-[20px]" />}
    </div>
  )
}
